import type { ComposerDraftSnapshot } from '@/components/Messenger/shared/messengerComposerDraftSync';

export type PendingAgentDraftSend = { chatId: string; text: string };

export function createAgentComposerDraftSnapshot(text: string): ComposerDraftSnapshot {
  return {
    text,
    reply_to_message_id: null,
    forward_message_ids: [],
  };
}

export function extractAgentComposerTextFromParts(
  parts: ReadonlyArray<{ type?: string; text?: string }> | undefined,
): string {
  if (!parts?.length) return '';
  const texts: string[] = [];
  for (const p of parts) {
    if (p?.type === 'text' && typeof p.text === 'string') {
      texts.push(p.text);
    }
  }
  return texts.join('\n');
}

/** Marks a send (including retry) so onFinish can clear the persisted composer draft. */
export function createPendingAgentDraftSend(
  chatId: string | null | undefined,
  text: string,
): PendingAgentDraftSend | null {
  const normalizedChatId = typeof chatId === 'string' ? chatId.trim() : '';
  if (!normalizedChatId) return null;
  return { chatId: normalizedChatId, text };
}
